import { render, staticRenderFns } from "./SingleImageSetting.vue?vue&type=template&id=0b05c59a&scoped=true&"
import script from "./SingleImageSetting.vue?vue&type=script&lang=ts&"
export * from "./SingleImageSetting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b05c59a",
  null
  
)

export default component.exports